import * as SwitchPrimitive from '@radix-ui/react-switch';
import clsx from 'clsx';

export function Switch({ className, ...props }: SwitchPrimitive.SwitchProps) {
  return (
    <SwitchPrimitive.Root
      className={clsx(
        'peer data-[state=checked]:bg-brand-default data-[state=unchecked]:bg-neutral-subtle outline-neutral-subtle h-lg inline-flex w-[36px] shrink-0 items-center rounded-full transition-all focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb className="bg-base-white size-md shadow-switch-thumb pointer-events-none block rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[18px] data-[state=unchecked]:translate-x-[2px]" />
    </SwitchPrimitive.Root>
  );
}
